import React, { Component } from 'react';
import './style.css';
import { Input, Button } from 'reactstrap';
import * as FontAwesome from 'react-icons/lib/fa'
import { Link } from 'react-router-dom';
import Loader from './../../loader/loader';
import { tarot_en } from './../../../../utils/horoscope_en';
import { tarot_es } from './../../../../utils/horoscope_es';
import { tarot_gr } from './../../../../utils/horoscope_gr';
import { tarot_ee } from './../../../../utils/horoscope_ee';
import { tarot_nl } from './../../../../utils/horoscope_nl';
import { tarot_fr } from './../../../../utils/horoscope_fr';
import { tarot_ar } from './../../../../utils/horoscope_ar';
import { tarot_hu } from './../../../../utils/horoscope_hu';
import { tarot_no } from './../../../../utils/horoscope_no';
import { tarot_vn } from './../../../../utils/horoscope_vn';
import { tarot_pl } from './../../../../utils/horoscope_pl';
import { tarot_se } from './../../../../utils/horoscope_se';
import { tarot_cy } from './../../../../utils/horoscope_cy';
import { tarot_ro } from './../../../../utils/horoscope_ro';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
class DailyTarot extends Component {
    constructor(props) {
        super(props)
        this.state = {
            contentLoading: true
        }
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        setTimeout(() => this.setState({ contentLoading: false }), 1500);
    }
    render() {
        let tarot = [];
        let countryCode = JSON.parse(sessionStorage.getItem('countryCode'));
        if (countryCode.countryCode === 'es' || countryCode.countryCode === 'mx') {
            tarot = tarot_es
        } else if (countryCode.countryCode === 'gr') {
            tarot = tarot_gr
        }else if (countryCode.countryCode === 'ee') {
            tarot = tarot_ee
        }else if (countryCode.countryCode === 'nl') {
            tarot = tarot_nl
        }else if (countryCode.countryCode === 'fr') {
            tarot = tarot_fr
        } else if (countryCode.countryCode === 'eg' || countryCode.countryCode === 'ps' || countryCode.countryCode === 'jo') {
            tarot = tarot_ar
        } else if (countryCode.countryCode === 'hu') {
            tarot = tarot_hu
        } 
        else if (countryCode.countryCode === 'no') {
            tarot = tarot_no
        } 
        else if (countryCode.countryCode === 'vn') {
            tarot = tarot_vn
        }  
        else if (countryCode.countryCode === 'pl') {
            tarot = tarot_pl
        }           
        else if (countryCode.countryCode === 'se') {
            tarot = tarot_se
        }  
        else if (countryCode.countryCode === 'rs') {
            tarot = tarot_cy
        }
        else if (countryCode.countryCode === 'ro') {
            tarot = tarot_ro
        }           
        else {
            tarot = tarot_en
        }

        let tarodCard = this.props.location.state.reading;
        let reading = tarot[this.props.location.state.reading];
        const readingWithName = reading.replace("readerName", this.props.location.state.name);
        const { contentLoading } = this.state;
        if (contentLoading) {
            return <Loader />
        }
        return (
            <div className="tarotreading">
                <div className="tarotreading-box">
                    <div className="tarot-item tarot-headeing">
                        <div className={(countryCode.countryCode === 'eg' || countryCode.countryCode === 'ps' || countryCode.countryCode === 'jo')? "tarotreading-btn-section-arabic":"tarotreading-btn-section"}>
                            <Link to="/tarotReading"><img src={require('./../../../assets/images/back-button.png')} className="back-button" /></Link>
                        </div>
                        <div className="heading-title">
                            <h1><FormattedMessage id="tarotreading.title"
                                defaultMessage="Tarot Reading"
                                description=""
                                values={{}} /></h1>
                        </div>
                    </div>
                    <div className="tarot-item" >
                        <div className="tarot-reading" >
                            <div className="tarot-reading-card tarot-card-padding-right">
                                <img src={require(`./../../../assets/images/tarotcards/tarot-card-${tarodCard}.jpg`)} width="195" height="150" />
                            </div>
                            <div className="tarot-reading-card tarot-card-padding-right">
                                <img src={require(`./../../../assets/images/tarotcards/tarot-card-${tarodCard + 1}.jpg`)} width="195" height="150" />
                            </div>
                            <div className={(countryCode.countryCode === "eg" || countryCode.countryCode === "ps" || countryCode.countryCode === "jo")? "tarot-card-padding-right tarot-reading-card":"tarot-reading-card"}>
                                <img src={require(`./../../../assets/images/tarotcards/tarot-card-${tarodCard + 2}.jpg`)} width="195" height="150" />
                            </div>
                        </div>
                    </div>
                    <div className={"tarot-item"}>
                        <p className="daily-tarot text-bold text-color big">
                            <FormattedMessage id="tarotreading.subtitle"
                                defaultMessage="Daily Tarot"
                                description=""
                                values={{}} />
                        </p>
                        <p>{readingWithName}</p>
                    </div>
                </div>
            </div >
        )
    }
}

export default DailyTarot;


// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/tarotreading/dailyTarot.js